// extracted by mini-css-extract-plugin
export default {"friends_section":"friends_friends_section__oOpkZ","frinedsDiv":"friends_frinedsDiv__EWD0L","add_input":"friends_add_input__Cgzz+","active_friends":"friends_active_friends__8IS-g"};